import { STARTED, UNINITIALIZED, FAILED, SUCCEEDED } from '../constants/AsyncStatuses';
export const isUninitialized = status => status === UNINITIALIZED;
export const isStarted = status => status === STARTED;
export const isUninitializedOrStarted = status => [UNINITIALIZED, STARTED].includes(status);
export const isFailed = status => status === FAILED;
export const isSucceeded = status => status === SUCCEEDED;